module.exports = __webpack_public_path__ + "9ddcaa17822e86dbae6cde4fb984aa55.pdf";